import { Icon } from '@zillow/constellation-10';
import { IconFileOutline, IconPhotosOutline, IconVideoCameraOutline } from '@zillow/constellation-icons';
import { FILE_TYPES } from '../../constants';

type AttachmentIconProps = {
  fileType: string;
};

export default function AttachmentIcon({ fileType }: AttachmentIconProps) {
  const isImageFileType = fileType.includes(FILE_TYPES.IMAGE);
  const isVideoFileType = fileType.includes(FILE_TYPES.VIDEO);

  if (isImageFileType) {
    return <Icon render={<IconPhotosOutline />} title="Placeholder image" size="sm" />;
  } else if (isVideoFileType) {
    return <Icon render={<IconVideoCameraOutline />} title="Video attachment" size="sm" />;
  } else {
    return <Icon data-testid="file-attachment-icon" render={<IconFileOutline />} title="File attachment" size="sm" />;
  }
}
